import PropTypes from 'prop-types';
import React from 'react';

const Background = (props) => {
  const {
    className,
    onClick,
  } = props;

  return (<div
    className={`dimmed-background ${className}`}
    onClick={onClick}
  />);
};

Background.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Background;



// WEBPACK FOOTER //
// ./src/components/Background.js